import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

const initialState: IMdbError | null = null;

export const themeSpecsDeleteFailureSlice = createSlice({
  name: 'themeSpecsDeleteFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    themeSpecsDeleteFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    themeSpecsDeleteFailureClear(state) {
      return null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { themeSpecsDeleteFailureChange, themeSpecsDeleteFailureClear } = themeSpecsDeleteFailureSlice.actions;

// export the core reducer for the slice
export const themeSpecsDeleteFailureReducer = themeSpecsDeleteFailureSlice.reducer;

export default themeSpecsDeleteFailureSlice.reducer;